import api from './api';

export const proxyLlm = async (model: string, prompt: string) => {
    const response = await api.post('/api/llm', { model, prompt });
    return response.data;
};
